import { render } from "./total_control.vue?vue&type=template&id=eb99f878"
import script from "./total_control.vue?vue&type=script&lang=js"
export * from "./total_control.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__